import React from 'react';
import DateRangeReportTable from '../../components/DateRangeReportTable';
import {
    amountBodyTemplate,
    bankPaymentStatusBodyTemplate,
    createPaymentMethodTemplate,
    dateTimeBody
} from '../../../../utils/tableTemplates';

const COLUMNS = [
    {field: 'policyNumber', header: 'Policy Number', sortable: true},
    {field: 'productName', header: 'Product Name', sortable: true},
    {field: 'payerName', header: 'Payer Name', sortable: true},
    {field: 'userId', header: 'Agent ID', sortable: true},
    {field: 'paymentMethod', header: 'Payment Method', body: createPaymentMethodTemplate('uppercase'), sortable: true},
    {field: 'amount', header: 'Amount', body: amountBodyTemplate, sortable: true},
    {field: 'paymentStatus', header: 'Payment Status', body: bankPaymentStatusBodyTemplate, sortable: true},
    {field: 'timeStamp', header: 'Timestamp', body: dateTimeBody('timeStamp'), sortable: true},
];

const LABELS = {
    notFound: 'Device not found.',
    failure: 'Failed to fetch device report. Please try again.',
    success: 'Device report loaded successfully',
    emptyMessage: 'No payment records found. Please enter a serial number, select a date range, and generate report.',
};

const DeviceReportsTable = () => (
    <DateRangeReportTable
        title="POS Device Report"
        exportName="Device Payments"
        endpoint="report/device"
        param={{name: 'serialNumber', label: 'Device Serial No.', required: true}}
        columns={COLUMNS}
        labels={LABELS}
        useParamAsFilename
    />
);

export default DeviceReportsTable;
